import './App.css';
import Header  from './components/layouts/header';
import LandingPage from './components/pages/productComparison/landingPage';
import ContactUs from './components/pages/contactus';
import { Routes, Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import AboutUs from './components/pages/aboutus';
import Premium from './components/pages/products/premium';
import Multibagger from './components/pages/products/multibagger';
import PremiumThankyou from './components/pages/thankyouPages/premiumThankyou';
import Momentum from './components/pages/products/momentum';
import Midterm from './components/pages/products/midterm';
import Longterm from './components/pages/products/longterm';
import ReviewsPage from './components/pages/reviews';
import Testimonials from './components/pages/testimonials';
import GoogleTagTracker from './GoogleTagTracker'
import ReportsPage from './components/pages/reports/report';
import ReviewsTestimonials from './components/pages/reviews_testimonials/reviews_testimonials_combine';

function App() {


  return (
    <>
      <BrowserRouter>
          <GoogleTagTracker/>
          <Routes>
            <Route path="/research" element={<ReportsPage />} />
            <Route path="/products" element={<LandingPage/>} />
            <Route path="/test" element={<Header />} />
            <Route path="/contact" element={<ContactUs />} />
            {/* <Route path='/reviews' element= {<ReviewsPage />} /> */}
            <Route path='/reviews' element= {<ReviewsTestimonials />} />
            {/* <Route path='/testimonials' element={<Testimonials />} /> */}
            <Route path='/about' element= {<AboutUs />} />
            <Route path='/reports' element= {<ReportsPage />} />
            <Route path='/products/premium' element= {<Premium />} />
            <Route path='/products/multibagger' element= {<Multibagger />} />
            <Route path='/products/premium/thankyou' element = {<PremiumThankyou />} />
            <Route path='/products/momentum' element = {<Momentum />} />
            <Route path='/products/midterm' element = {<Midterm />} />
            <Route path='/products/longterm' element = {<Longterm />} />
            <Route path="*" element={<ReportsPage />} />
          </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
